import React from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";
import ChartistGraph from "react-chartist";

import config from "config.js";

import { Link } from "react-router-dom";
import loadContent from "core-module/hoc/loadContent";

import Timeline from "@material-ui/icons/Timeline";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

var Chartist = require("chartist");

const donutVariables = {
  options: {
    donut: true,
    donutWidth: 15,
    startAngle: 0,
    showLabel: true,
    labelOffset: -70,
  },
  // for animation
  animation: {
    draw: function (data) {
      if (data.type === "slice") {
        // Get the total path length in order to use for dash array animation
        var pathLength = data.element._node.getTotalLength();

        // Set a dasharray that matches the path length as prerequisite to animate dashoffset
        data.element.attr({
          "stroke-dasharray": pathLength + "px " + pathLength + "px",
        });

        // Create animation definition while also assigning an ID to the animation for later sync usage
        var animationDefinition = {
          "stroke-dashoffset": {
            id: "anim" + data.index,
            dur: 200,
            from: -pathLength + "px",
            to: "0px",
            easing: Chartist.Svg.Easing.easeOutQuint,
            // We need to use `fill: 'freeze'` otherwise our animation will fall back to initial (not visible)
            fill: "freeze",
          },
        };

        // If this was not the first slice, we need to time the animation so that it uses the end sync event of the previous animation
        if (data.index !== 0) {
          animationDefinition["stroke-dashoffset"].begin =
            "anim" + (data.index - 1) + ".end";
        }

        // We need to set an initial value before the animation starts as we are not in guided mode which would do that for us
        data.element.attr({
          "stroke-dashoffset": -pathLength + "px",
        });

        // We can't use guided mode as the animations need to rely on setting begin manually
        // See http://gionkunz.github.io/chartist-js/api-documentation.html#chartistsvg-function-animate
        data.element.animate(animationDefinition, false);
      }
    },
  },
};

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  cardIconTitle: importedStyle.cardIconTitle,
  stats: importedStyle.stats,
};

const remainingDays = (props) => {
  let date = new Date();
  let time = new Date();
  time.setMonth(date.getMonth() + 1);
  time.setDate(0);
  return time.getDate() > date.getDate() ? time.getDate() - date.getDate() : 0;
};

const DataUsageDonut = (props) => {
  const { classes } = props;
  const used = props.getData("used_gb");
  const base = props.getData("base_cap");

  let percentage, total;
  if (/^9+$/.test(base)) {
    total = "Unlimited";
    percentage = 0;
  } else {
    total = props.getData("total_cap");
    percentage = Math.round((used / total) * 100).toFixed(0);
  }

  const daysleft = remainingDays();
  const dayText = daysleft === 1 ? "day" : "days";
  return (
    <Link to={config.MYACCOUNT.APP_PATH + "/user/calendar"}>
      <Card>
        <CardHeader color="primary" icon>
          <CardIcon color="primary">
            <Timeline />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Current Month Data Usage</h4>
        </CardHeader>
        <CardBody>
          <GridContainer align="center">
            <GridItem xs={12}>
              <br />
              <ChartistGraph
                className="ct-pie-datausage"
                data={{
                  series: [
                    {
                      value: 100,
                      className: "ct-pie-datausage-serie-grey",
                    },
                    {
                      value: percentage,
                      className:
                        "ct-pie-datausage-serie-main-" +
                        (percentage >= 100
                          ? "red"
                          : percentage >= 95
                            ? "orange"
                            : "green"),
                    },
                  ],
                  labels: [" " + percentage + "%", " "],
                }}
                type="Pie"
                options={{
                  ...donutVariables.options,
                  total: 100,
                }}
                listener={donutVariables.animation}
              />
            </GridItem>
            <GridItem xs={12}>
              <br />
              <br />
              <br />
              <h3 className={classes.cardTitle}>
                {used} <small>GB</small> {" / "} {total} <small>GB</small>
              </h3>
              <h4 className={classes.cardTitle}>
                ({daysleft} {dayText} left)
              </h4>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem>
              <br />
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    </Link>
  );
};

export default withStyles(styles)(
  loadContent("user.session/broadbandtraffic", DataUsageDonut),
);
